// SignupForm.js
import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "./SignupForm.css";
import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { Link, useNavigate } from 'react-router-dom';

const SignupForm = () => {
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "fullName") setFullName(value);
    else if (name === "mobileNumber") setMobileNumber(value);
    else if (name === "email") setEmail(value);
    else if (name === "password") setPassword(value);
    else if (name === "confirmPassword") setConfirmPassword(value);

    // Show submit button only if all fields are filled except mobile number
    // if (fullName && email && password && confirmPassword) {
    //   setShowSubmitButton(true);
    // } else {
    //   setShowSubmitButton(false);
    // }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const passwordRegex =
      /^(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    } else if (!passwordRegex.test(password)) {
      alert(
        "Password must contain at least one lowercase alphabet, one special character, one number, and be at least 6 characters long"
      );
      return;
    } else {
      try {
        const auth = getAuth();
        setShowSubmitButton(false); // Disable the submit button during sign-up process

        // Create a new user with email and password
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        await updateProfile(userCredential.user, {
          displayName: fullName,
          mobile: mobileNumber,
        });

        // Handle successful sign-up (e.g., navigate to a new page)
        // You can use history.push('/path') to navigate to a new page if needed
        console.log("Sign-up successful");
        navigate('/auth/login');
      } catch (error) {
        alert(error.message);
      } finally {
        setShowSubmitButton(true); // Enable the submit button after sign-up attempt
      }
    }
  };

  return (
    <div className="auth-form">
      <h2>Sign up</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={fullName}
          onChange={handleInputChange}
          className="inputContainer"
        />
        <input
          type="tel"
          name="mobileNumber"
          placeholder="Mobile Number"
          value={mobileNumber}
          onChange={handleInputChange}
          className="inputContainer"
        />
        <input
          type="email"
          name="email"
          placeholder="Email ID"
          value={email}
          onChange={handleInputChange}
          className="inputContainer"
        />
        <input
          type="password"
          name="password"
          placeholder="Choose Password"
          value={password}
          onChange={handleInputChange}
          className="inputContainer"
        />
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Chosen Password"
          value={confirmPassword}
          onChange={handleInputChange}
          className="inputContainer"
        />
        {showSubmitButton && (
          <button className="submit-button" type="submit">
            Sign Up
          </button>
        )}
      </form>
      <div className="login-link">
        {/* <Link to="/login">Already have an account? Log in</Link> */}
      </div>
    </div>
  );
};

export default SignupForm;
